/**
 * Get keyword or model search terms either from
 * user input or decoded query string
 *
 * @param   {string} input
 * @param   {string} groupBy
 * @returns {array}
 */
export default function getSearchTerms(
  input,
  groupBy = "OR",
  checkQuotes = true
) {
  input = `${input}`.trim();
  groupBy = `${groupBy}`.toUpperCase() === "AND" ? "AND" : "OR";

  let newTerms;

  if (!checkQuotes) {
    const splitBy = groupBy === "AND" ? "OR" : "AND";
    const splitPattern = new RegExp(` ${splitBy} `, "gi");
    newTerms = !!input && input.split(splitPattern);
  } else {
    const term = '((\\([^)]+\\))|("[^"]+")|([^\\s"]+))';
    const pattern = new RegExp(`${term}( ${groupBy} ${term})*`, "gi");
    newTerms = !!input && input.replace(/[“”]/g, '"').match(pattern);
  }

  if (!!newTerms && !!newTerms.length) {
    const normalizeGroupBy = new RegExp(` ${groupBy} `, "gi");
    newTerms = newTerms
      .filter(
        term =>
          !!term && term.toUpperCase() !== "AND" && term.toUpperCase() !== "OR"
      )
      .map(term => {
        term = term.replace(/["()]/g, "").split(normalizeGroupBy);
        term = [...new Set([...term])].join(` ${groupBy} `);
        return term;
      });
  }

  return newTerms;
}
